export const addDay = (today, days) => {
  let date = new Date(today);

  date.setDate(date.getDate() + days);

  return date;
};

export const dueDateFormat = (day, month, year) => {
  const months = [
    'Januari',
    'Februari',
    'Maret',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Agustus',
    'September',
    'Oktober',
    'November',
    'Desember'
  ];
  const date = day + ' ' + months[month] + ' ' + year;
  return date;
};

export const formatLocalTime = fulldate => {
  const offset = fulldate.getTimezoneOffset();
  const time = offset / -60;

  if (time === 7) {
    return 'WIB';
  } else if (time === 8) {
    return 'WITA';
  } else if (time === 9) {
    return 'WIT';
  }

  return '';
};

export const addZero = time => {
  if (time < 10) {
    time = '0' + time;
  }
  return time;
};

export const dueDateTimeFormat = date => {
  return dueDateFormat(date.getDate(), date.getMonth(), date.getFullYear());
  // ' ' +
  // addZero(date.getHours()) +
  // ':' +
  // addZero(date.getMinutes()) +
  // ' ' +
  // formatLocalTime(date)
};
